import React, { useEffect } from "react";
import { baseContainer, Logger, setAvatar } from "@base-provider";
import SFAvatar from ".";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { saveUserAvatar } from "../../services/configurationService";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const SFAvatarStyled = styled(SFAvatar)(({ sx }) => ({
  ...sx,
  fontSize: "10px",
  lineHeight: "12px"
}));

const UserAvatar = ({ name, sx = {}, sxNoImage = {} }) => {
  const dispatch = useDispatch();
  Logger.of("App.Core.UserAvatar").info({ name });

  const avatar = useSelector((state) => {
    return state.session.avatar;
  });

  useEffect(() => {
    const getAvatar = async () => {
      if (!avatar) {
        const res = await baseContainer.activeDirectoryService.getUserAvatar();
        if (res) {
          dispatch(setAvatar(res));
          saveUserAvatar(res);
        }
      }
    };
    getAvatar();
  }, []);

  const combinedSx = avatar ? { ...sx } : { ...sx, ...sxNoImage };
  return <SFAvatarStyled  src={avatar} name={name} sx={combinedSx} />;
};

export const CustomAvatar = ({ name, sx = {} }) => {
  Logger.of("App.Core.CustomAvatar").info({ name });

  return <SFAvatarStyled name={name} sx={sx} />;
};

UserAvatar.propTypes = {
  name: PropTypes.string.isRequired,
};

export default UserAvatar;
